import React from 'react';
import '../styles/merryChristmas.css';

const MerryChristmas: React.FC = () => {
  return (
    <div className="merry-christmas-page">
      <img
        src="/images/Merry-3.jpg"
        alt="Merry Christmas & Happy New Year from FTDiam"
        className="merry-christmas-page__image"
      />
    </div>
  );
};

export default MerryChristmas;
